export default "__VITE_ASSET__BjssJIrU__"